"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = _vue2.default.extend({
    name: "HeMultiSelect",
    props: {
        value: {
            default: null
        },
        name: {
            default: null
        },
        options: {
            default: function _default() {
                return [];
            }
        },
        /**
         * Piqué à Bootstrap :
         * Remove some borders and rounded corners to render list group items edge-to-edge in a parent container
         */
        flush: {
            type: Boolean,
            default: false
        },
        /**
         * Rajoute du hover et du background pour donner aux utilisateurs l'envie de cliquer
         */
        action: {
            type: Boolean,
            default: true
        },
        // L'option "toute" {{
        allOptionEnable: {
            type: Boolean,
            default: true
        },
        allOptionCaption: {
            type: String,
            default: "Tous"
        },
        allOptionId: {
            default: null
        }
        // }}
    },
    data: function data() {
        return {
            $selected: this.normalizeSelection(this.value),
            diplayOptions: this.availableOptions
        };
    },

    watch: {
        value: function value(nv) {
            this.$set(this.$data, "$selected", this.normalizeSelection(nv));
        },
        options: function options(n) {
            this.$set(this.$data, "diplayOptions", this.availableOptions);
        }
    },
    methods: {
        isSelected: function isSelected(option) {
            return this.$data.$selected.indexOf(option.id) > -1;
        },
        normalizeSelection: function normalizeSelection(selection) {
            if ((selection == null || selection.length === 0) && this.allOptionEnable) {
                return [this.allOptionId];
            }

            return [].concat(_toConsumableArray(selection));
        },
        onItemClick: function onItemClick(option) {
            var _this = this;

            if (option.$isAllOption) {
                this.$data.$selected = [this.allOptionId];
                this.$emit("input", this.$data.$selected);

                return;
            }

            if (this.isSelected(option)) {
                this.$data.$selected = this.$data.$selected.filter(function (v) {
                    return v !== option.id;
                });
            } else {
                this.$data.$selected.push(option.id);

                if (this.allOptionEnable) {
                    this.$data.$selected = this.$data.$selected.filter(function (v) {
                        return v !== _this.allOptionId;
                    });
                }
            }

            if (this.$data.$selected.length == 0 && this.allOptionEnable && this.allOptionId !== null) {
                this.$data.$selected.push(this.allOptionId);
            }

            this.$emit("input", this.$data.$selected);
        }
    },
    computed: {
        availableOptions: function availableOptions() {
            var ret = [];

            if (this.options && this.options.length > 0) {
                if (this.allOptionEnable) {
                    ret.push({
                        $isAllOption: true,
                        id: this.allOptionId,
                        text: this.allOptionCaption
                    });
                }

                ret = ret.concat(this.options);
            }

            return ret;
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/SharedComponent/HeMultiselect/HeMultiselect.vue
// module id = 222
// module chunks = 0